// extracted by extract-css-chunks-webpack-plugin
module.exports = {"name":"name_1WF5g","name_inverted":"name_inverted_263OL"};